<script setup>
import { computed, onMounted, ref } from 'vue'
import { useUsersStore } from '../stores/users.js'

const props = defineProps({
  userId: Number,
})

const usersStore = useUsersStore()
const loaded = ref(false)

onMounted(async () => {
  await usersStore.loadUserSubOrgs(props.userId)
  loaded.value = true
})

const subOrgs = computed(() => {
  if (!loaded.value) return undefined
  return usersStore.getUserSubOrgs(props.userId)
})
</script>

<template>
  <div>
    <span v-if="subOrgs === undefined">...</span>
    <span v-else-if="subOrgs.length === 0">-</span>
    <span v-else>
      {{ subOrgs.map(s => s.name).join(', ') }}
    </span>
  </div>
</template>
